import { r as react } from './index-3eed8459.js';
import { I as Icon } from './PictureTwoTone-d47a1b1b.js';

// This icon file is generated automatically.
var ArrowLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowLeftOutlined$1 = function ArrowLeftOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlined
  }));
};

ArrowLeftOutlined$1.displayName = 'ArrowLeftOutlined';
var ArrowLeftOutlined$2 = /*#__PURE__*/react.forwardRef(ArrowLeftOutlined$1);

// This icon file is generated automatically.
var ArrowRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowRightOutlined$1 = function ArrowRightOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowRightOutlined
  }));
};

ArrowRightOutlined$1.displayName = 'ArrowRightOutlined';
var ArrowRightOutlined$2 = /*#__PURE__*/react.forwardRef(ArrowRightOutlined$1);

// This icon file is generated automatically.
var BarsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarsOutlined$1 = function BarsOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: BarsOutlined
  }));
};

BarsOutlined$1.displayName = 'BarsOutlined';
var BarsOutlined$2 = /*#__PURE__*/react.forwardRef(BarsOutlined$1);

// This icon file is generated automatically.
var CalendarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CalendarOutlined$1 = function CalendarOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarOutlined
  }));
};

CalendarOutlined$1.displayName = 'CalendarOutlined';
var CalendarOutlined$2 = /*#__PURE__*/react.forwardRef(CalendarOutlined$1);

// This icon file is generated automatically.
var CaretDownFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretDownFilled$1 = function CaretDownFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownFilled
  }));
};

CaretDownFilled$1.displayName = 'CaretDownFilled';
var CaretDownFilled$2 = /*#__PURE__*/react.forwardRef(CaretDownFilled$1);

// This icon file is generated automatically.
var CaretDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretDownOutlined$1 = function CaretDownOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownOutlined
  }));
};

CaretDownOutlined$1.displayName = 'CaretDownOutlined';
var CaretDownOutlined$2 = /*#__PURE__*/react.forwardRef(CaretDownOutlined$1);

// This icon file is generated automatically.
var CaretUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretUpOutlined$1 = function CaretUpOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpOutlined
  }));
};

CaretUpOutlined$1.displayName = 'CaretUpOutlined';
var CaretUpOutlined$2 = /*#__PURE__*/react.forwardRef(CaretUpOutlined$1);

// This icon file is generated automatically.
var CheckCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleOutlined$1 = function CheckCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleOutlined
  }));
};

CheckCircleOutlined$1.displayName = 'CheckCircleOutlined';
var CheckCircleOutlined$2 = /*#__PURE__*/react.forwardRef(CheckCircleOutlined$1);

// This icon file is generated automatically.
var ClockCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleOutlined$1 = function ClockCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleOutlined
  }));
};

ClockCircleOutlined$1.displayName = 'ClockCircleOutlined';
var ClockCircleOutlined$2 = /*#__PURE__*/react.forwardRef(ClockCircleOutlined$1);

// This icon file is generated automatically.
var CloseCircleOutlined = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" } }] }, "name": "close-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleOutlined$1 = function CloseCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleOutlined
  }));
};

CloseCircleOutlined$1.displayName = 'CloseCircleOutlined';
var CloseCircleOutlined$2 = /*#__PURE__*/react.forwardRef(CloseCircleOutlined$1);

// This icon file is generated automatically.
var CopyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyOutlined$1 = function CopyOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: CopyOutlined
  }));
};

CopyOutlined$1.displayName = 'CopyOutlined';
var CopyOutlined$2 = /*#__PURE__*/react.forwardRef(CopyOutlined$1);

// This icon file is generated automatically.
var DoubleLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleLeftOutlined$1 = function DoubleLeftOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlined
  }));
};

DoubleLeftOutlined$1.displayName = 'DoubleLeftOutlined';
var DoubleLeftOutlined$2 = /*#__PURE__*/react.forwardRef(DoubleLeftOutlined$1);

// This icon file is generated automatically.
var DoubleRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleRightOutlined$1 = function DoubleRightOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlined
  }));
};

DoubleRightOutlined$1.displayName = 'DoubleRightOutlined';
var DoubleRightOutlined$2 = /*#__PURE__*/react.forwardRef(DoubleRightOutlined$1);

// This icon file is generated automatically.
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownOutlined$1 = function DownOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: DownOutlined
  }));
};

DownOutlined$1.displayName = 'DownOutlined';
var DownOutlined$2 = /*#__PURE__*/react.forwardRef(DownOutlined$1);

// This icon file is generated automatically.
var EditOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EditOutlined$1 = function EditOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: EditOutlined
  }));
};

EditOutlined$1.displayName = 'EditOutlined';
var EditOutlined$2 = /*#__PURE__*/react.forwardRef(EditOutlined$1);

// This icon file is generated automatically.
var EllipsisOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EllipsisOutlined$1 = function EllipsisOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlined
  }));
};

EllipsisOutlined$1.displayName = 'EllipsisOutlined';
var EllipsisOutlined$2 = /*#__PURE__*/react.forwardRef(EllipsisOutlined$1);

// This icon file is generated automatically.
var EnterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EnterOutlined$1 = function EnterOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: EnterOutlined
  }));
};

EnterOutlined$1.displayName = 'EnterOutlined';
var EnterOutlined$2 = /*#__PURE__*/react.forwardRef(EnterOutlined$1);

// This icon file is generated automatically.
var ExclamationCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleFilled$1 = function ExclamationCircleFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleFilled
  }));
};

ExclamationCircleFilled$1.displayName = 'ExclamationCircleFilled';
var ExclamationCircleFilled$2 = /*#__PURE__*/react.forwardRef(ExclamationCircleFilled$1);

// This icon file is generated automatically.
var ExclamationCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleOutlined$1 = function ExclamationCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlined
  }));
};

ExclamationCircleOutlined$1.displayName = 'ExclamationCircleOutlined';
var ExclamationCircleOutlined$2 = /*#__PURE__*/react.forwardRef(ExclamationCircleOutlined$1);

// This icon file is generated automatically.
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleOutlined$1 = function EyeInvisibleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlined
  }));
};

EyeInvisibleOutlined$1.displayName = 'EyeInvisibleOutlined';
var EyeInvisibleOutlined$2 = /*#__PURE__*/react.forwardRef(EyeInvisibleOutlined$1);

// This icon file is generated automatically.
var FileOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileOutlined$1 = function FileOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: FileOutlined
  }));
};

FileOutlined$1.displayName = 'FileOutlined';
var FileOutlined$2 = /*#__PURE__*/react.forwardRef(FileOutlined$1);

// This icon file is generated automatically.
var FilterFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilterFilled$1 = function FilterFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilled
  }));
};

FilterFilled$1.displayName = 'FilterFilled';
var FilterFilled$2 = /*#__PURE__*/react.forwardRef(FilterFilled$1);

// This icon file is generated automatically.
var FolderOpenOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenOutlined$1 = function FolderOpenOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenOutlined
  }));
};

FolderOpenOutlined$1.displayName = 'FolderOpenOutlined';
var FolderOpenOutlined$2 = /*#__PURE__*/react.forwardRef(FolderOpenOutlined$1);

// This icon file is generated automatically.
var FolderOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOutlined$1 = function FolderOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOutlined
  }));
};

FolderOutlined$1.displayName = 'FolderOutlined';
var FolderOutlined$2 = /*#__PURE__*/react.forwardRef(FolderOutlined$1);

// This icon file is generated automatically.
var InfoCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleFilled$1 = function InfoCircleFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleFilled
  }));
};

InfoCircleFilled$1.displayName = 'InfoCircleFilled';
var InfoCircleFilled$2 = /*#__PURE__*/react.forwardRef(InfoCircleFilled$1);

// This icon file is generated automatically.
var InfoCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleOutlined$1 = function InfoCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleOutlined
  }));
};

InfoCircleOutlined$1.displayName = 'InfoCircleOutlined';
var InfoCircleOutlined$2 = /*#__PURE__*/react.forwardRef(InfoCircleOutlined$1);

// This icon file is generated automatically.
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftOutlined$1 = function LeftOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: LeftOutlined
  }));
};

LeftOutlined$1.displayName = 'LeftOutlined';
var LeftOutlined$2 = /*#__PURE__*/react.forwardRef(LeftOutlined$1);

// This icon file is generated automatically.
var MinusSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareOutlined$1 = function MinusSquareOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareOutlined
  }));
};

MinusSquareOutlined$1.displayName = 'MinusSquareOutlined';
var MinusSquareOutlined$2 = /*#__PURE__*/react.forwardRef(MinusSquareOutlined$1);

// This icon file is generated automatically.
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusOutlined$1 = function PlusOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: PlusOutlined
  }));
};

PlusOutlined$1.displayName = 'PlusOutlined';
var PlusOutlined$2 = /*#__PURE__*/react.forwardRef(PlusOutlined$1);

// This icon file is generated automatically.
var PlusSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareOutlined$1 = function PlusSquareOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareOutlined
  }));
};

PlusSquareOutlined$1.displayName = 'PlusSquareOutlined';
var PlusSquareOutlined$2 = /*#__PURE__*/react.forwardRef(PlusSquareOutlined$1);

// This icon file is generated automatically.
var QuestionCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleOutlined$1 = function QuestionCircleOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleOutlined
  }));
};

QuestionCircleOutlined$1.displayName = 'QuestionCircleOutlined';
var QuestionCircleOutlined$2 = /*#__PURE__*/react.forwardRef(QuestionCircleOutlined$1);

// This icon file is generated automatically.
var RedoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedoOutlined$1 = function RedoOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: RedoOutlined
  }));
};

RedoOutlined$1.displayName = 'RedoOutlined';
var RedoOutlined$2 = /*#__PURE__*/react.forwardRef(RedoOutlined$1);

// This icon file is generated automatically.
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightOutlined$1 = function RightOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: RightOutlined
  }));
};

RightOutlined$1.displayName = 'RightOutlined';
var RightOutlined$2 = /*#__PURE__*/react.forwardRef(RightOutlined$1);

// This icon file is generated automatically.
var RotateLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateLeftOutlined$1 = function RotateLeftOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: RotateLeftOutlined
  }));
};

RotateLeftOutlined$1.displayName = 'RotateLeftOutlined';
var RotateLeftOutlined$2 = /*#__PURE__*/react.forwardRef(RotateLeftOutlined$1);

// This icon file is generated automatically.
var RotateRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateRightOutlined$1 = function RotateRightOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: RotateRightOutlined
  }));
};

RotateRightOutlined$1.displayName = 'RotateRightOutlined';
var RotateRightOutlined$2 = /*#__PURE__*/react.forwardRef(RotateRightOutlined$1);

// This icon file is generated automatically.
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SearchOutlined$1 = function SearchOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlined
  }));
};

SearchOutlined$1.displayName = 'SearchOutlined';
var SearchOutlined$2 = /*#__PURE__*/react.forwardRef(SearchOutlined$1);

// This icon file is generated automatically.
var StarFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StarFilled$1 = function StarFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: StarFilled
  }));
};

StarFilled$1.displayName = 'StarFilled';
var StarFilled$2 = /*#__PURE__*/react.forwardRef(StarFilled$1);

// This icon file is generated automatically.
var SwapRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapRightOutlined$1 = function SwapRightOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: SwapRightOutlined
  }));
};

SwapRightOutlined$1.displayName = 'SwapRightOutlined';
var SwapRightOutlined$2 = /*#__PURE__*/react.forwardRef(SwapRightOutlined$1);

// This icon file is generated automatically.
var UpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpOutlined$1 = function UpOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: UpOutlined
  }));
};

UpOutlined$1.displayName = 'UpOutlined';
var UpOutlined$2 = /*#__PURE__*/react.forwardRef(UpOutlined$1);

// This icon file is generated automatically.
var WarningFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WarningFilled$1 = function WarningFilled$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: WarningFilled
  }));
};

WarningFilled$1.displayName = 'WarningFilled';
var WarningFilled$2 = /*#__PURE__*/react.forwardRef(WarningFilled$1);

// This icon file is generated automatically.
var ZoomInOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomInOutlined$1 = function ZoomInOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ZoomInOutlined
  }));
};

ZoomInOutlined$1.displayName = 'ZoomInOutlined';
var ZoomInOutlined$2 = /*#__PURE__*/react.forwardRef(ZoomInOutlined$1);

// This icon file is generated automatically.
var ZoomOutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomOutOutlined$1 = function ZoomOutOutlined$1(props, ref) {
  return /*#__PURE__*/react.createElement(Icon, Object.assign({}, props, {
    ref: ref,
    icon: ZoomOutOutlined
  }));
};

ZoomOutOutlined$1.displayName = 'ZoomOutOutlined';
var ZoomOutOutlined$2 = /*#__PURE__*/react.forwardRef(ZoomOutOutlined$1);

export { ArrowLeftOutlined$2 as A, BarsOutlined$2 as B, CalendarOutlined$2 as C, DoubleLeftOutlined$2 as D, EditOutlined$2 as E, FileOutlined$2 as F, InfoCircleFilled$2 as I, LeftOutlined$2 as L, MinusSquareOutlined$2 as M, PlusOutlined$2 as P, QuestionCircleOutlined$2 as Q, RedoOutlined$2 as R, SearchOutlined$2 as S, UpOutlined$2 as U, WarningFilled$2 as W, ZoomInOutlined$2 as Z, ArrowRightOutlined$2 as a, CaretDownFilled$2 as b, CaretDownOutlined$2 as c, CaretUpOutlined$2 as d, CheckCircleOutlined$2 as e, ClockCircleOutlined$2 as f, CloseCircleOutlined$2 as g, CopyOutlined$2 as h, DoubleRightOutlined$2 as i, DownOutlined$2 as j, EllipsisOutlined$2 as k, EnterOutlined$2 as l, ExclamationCircleFilled$2 as m, ExclamationCircleOutlined$2 as n, EyeInvisibleOutlined$2 as o, FilterFilled$2 as p, FolderOpenOutlined$2 as q, FolderOutlined$2 as r, InfoCircleOutlined$2 as s, PlusSquareOutlined$2 as t, RightOutlined$2 as u, RotateLeftOutlined$2 as v, RotateRightOutlined$2 as w, StarFilled$2 as x, SwapRightOutlined$2 as y, ZoomOutOutlined$2 as z };
